import { createSlice } from '@reduxjs/toolkit';

import { ThunkGetMyPricePlan, ThunkGetPricePlans } from 'store/pricePlan/thunks';
import { IMyPricePlan, IPricePlan } from 'services/pricePlan/types';

interface IInitialState {
  pricePlan: IMyPricePlan | undefined;
  pricePlans: IPricePlan[];
}

const initialState: IInitialState = {
  pricePlan: undefined,
  pricePlans: [],
};

const pricePlanSlice = createSlice({
  name: 'pricePlan',
  reducers: {},
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetMyPricePlan.fulfilled, (state, action) => {
      state.pricePlan = action.payload;
    });

    builder.addCase(ThunkGetPricePlans.fulfilled, (state, action) => {
      state.pricePlans = action.payload.sort((a, b) =>
        a.basePriceCents > b.basePriceCents ? 1 : -1,
      );
    });
  },
});

export default pricePlanSlice.reducer;
